<template lang="html">
  <div
    id="landing-carousel"
    class="landing-carousel"
  >
    <transition-group
      tag="div"
      :name="transitionName"
      class="slides-group"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
    >
      <div
        v-if="show"
        :key="current"
        :class="[
          'landing-carousel__item slide',
        ]"
      >
        <div class="landing-carousel__container">
          <div class="landing-carousel__image">
            <div
              class="landing-carousel__image-bg"
              :style="{ 'background-image': 'url(' + style + ')' }"
            >
              <div
                v-if="currentArr.has_after_img"
                class="landing-carousel__image-bg-after"
                :style="{ 'background-image': 'url(' + styleAfterImg + ')' }"
              />
            </div>
          </div>
          <div class="landing-carousel__description">
            <div class="landing-carousel__description-title">
              {{ slideTitle }}
              <div class="landing-carousel__before-title-icon">
                <SVGIcon
                  :name="'sword'"
                  :colors="'180deg, rgb(255 255 255 / 0.15), rgb(255 255 255 / 0)'"
                />
              </div>
            </div>
            <div class="landing-carousel__description-subtitle">
              {{ slideSubtitle }}
            </div>
            <div class="landing-carousel__description-text" v-html="slideDescription" />
            <div class="landing-carousel__description-btn">
              <Button
                :ga="'buttonPlay'"
                :type="'without-border orange'"
                :height="'48px'"
                :tag="'a'"
              >
                Play Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <div class="landing-carousel__tabs">
      <div
        v-for="(tab, index) in $props.items"
        :key="index"
        :class="[
          'landing-carousel__tab',
          { 'active' : index === current },
        ]"
        @click="slide(index)"
        @mouseover="resetInterval()"
      >
        <div class="landing-carousel__dot">
          <div
            v-if="isActiveSection(index)"
            class="landing-carousel__inner-dot"
          />
        </div>
        <div
          v-if="isNotLastElement(index)"
          class="landing-carousel__progress-line"
        >
          <div
            :class="[
              'landing-carousel__progress-line-inner',
              { 'landing-carousel__progress-line-inner--active' : isActiveSection(index) },
              { 'landing-carousel__progress-line-inner--animate' : needAnimateProgressLine(index) },
            ]"
          />
        </div>
        <div
          :class="[
            'landing-carousel__tab-title',
          ]"
        >
          {{ translate(tab.type_name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
const QUICK_START = `${process.env.VUE_APP_BASE_API_URL}api/quickstart_auth?source=landing`;

import {
 gsap,
 TimelineMax,
 // Power2,
} from 'gsap/all';
import Button from '../../baseComponents/ui/Button.vue';
import SVGIcon from '../../baseComponents/ui/SVGIcon.vue';

export default {
  name: 'Srccomponentslandinglandingcarousel',
  components: {
    Button,
    SVGIcon,
  },
  props: {
    goToTutorial: {
      type: Function,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => {},
    },
    tabIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      quick_start_target: QUICK_START,
      carouselDuration: 8000,
      interval: 0,
      current: 0,
      direction: 1,
      transitionName: 'fade',
      show: false,
      windowWidth: window.innerWidth,
      animationController: null,
      animationDuration: 2,
      imageContainer: '.landing-carousel__image-bg',
      imageAfterContainer: '.landing-carousel__image-bg-after',
      descriptionContainer: '.landing-carousel__description',
    };
  },
  computed: {
    currentArr() {
      return this.$props.items[this.current];
    },
    slideTitle() {
      return this.$i18n.t(this.currentArr.title);
    },
    slideSubtitle() {
      return this.$i18n.t(this.currentArr.subtitle);
    },
    slideDescription() {
      return this.$i18n.t(this.currentArr.description);
    },
    slideFooterTitle() {
      return this.$i18n.t(this.currentArr.footer_title);
    },
    slideFooterDescription() {
      return this.$i18n.t(this.currentArr.footer_description);
    },
    slideTypeName() {
      return this.$i18n.t(this.currentArr.type_name);
    },
    slideTypeNameDescr() {
      return this.$i18n.t(this.currentArr.type_name_descr);
    },
    slideBtnText() {
      return this.$i18n.t(this.currentArr.btn_text);
    },
    getImgWithLang() {
      return this.currentArr[`img_background_${this.$i18n.locale}`];
    },
    getImgMobWithLang() {
      return this.currentArr[`img_background_mob_${this.$i18n.locale}`];
    },
    style() {
      return this.getImgWithLang;
    },
    styleAfterImg() {
      return this.currentArr[`img_background_${this.$i18n.locale}_after`];
    },
  },
  mounted() {
    this.show = true;
    window.addEventListener('resize', this.$lodash.debounce(this.handleResize, 150));
    this.animationController = new TimelineMax();
    this.action();
  },
  methods: {
    translate(data) {
      return this.$i18n.t(data);
    },
    slide(dir) {
      // eslint-disable-next-line
      dir > this.current ? (this.transitionName = 'slide-next') : (this.transitionName = 'slide-prev');
      this.current = dir;
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    beforeEnter() {
    },
    async enter() {
      await this.animateCarouselItem();
    },
    leave() {

    },
    animateCarouselItem() {
      const {
        animationController,
        animationDuration,
        imageContainer,
        imageAfterContainer,
        descriptionContainer,
      } = this;

      return new Promise((resolve) => {
        animationController.clear();
        animationController.add([
          gsap.fromTo(imageContainer,
            {
              opacity: 0,
              x: -300,
            }, {
              opacity: 1,
              x: 0,
              duration: animationDuration,
          }),
          gsap.fromTo(imageAfterContainer,
            {
              opacity: 0,
              yPercent: +60,
              scaleX:0.5,
              scaleY:0.5,
            }, {
              opacity: 1,
              yPercent: 0,
              scaleX:1,
              scaleY:1,
              duration: animationDuration*1.4,
            }).delay(1),
          gsap.fromTo(descriptionContainer,
            {
              opacity: 0,
              x: +300,
            }, {
              opacity: 1,
              x: 0,
              duration: animationDuration,
              onComplete: () => {
                resolve();
              }
            }).delay(1),
        ]);
      })
    },
    isNotLastElement(index) {
      return this.$props.items.length !== (index + 1);
    },
    isActiveSection(index) {
      return index <= this.current;
    },
    needAnimateProgressLine(index) {
      return index === this.current;
    },
    action() {
      this.interval = setInterval(()=>{
        this.current++;
        if( this.current === this.$props.items.length ) {
          this.current = 0;
        }
        this.slide( this.current );

      }, this.carouselDuration);
    },
    resetInterval() {
      clearInterval(this.interval);
      this.action();
    },
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
};
</script>

<style scoped lang="scss">

@import "../../../static/scss/main";
.btn {
  z-index: 10;
  cursor: pointer;
  border: 3px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  position: absolute;
  top: calc(50% - 35px);
  left: 1%;
  transition: transform 0.3s ease-in-out;
  user-select: none;
}

.btn-next {
  left: auto;
  right: 1%;
}

.btn:hover {
  transform: scale(1.1);
}

.landing-carousel__image {
  background: {
    image: url("/assets/images_new/landing-carousel__image__bg.png");
    size: cover;
    repeat: no-repeat;
  };
  @include position(absolute, 0, 0, 0, 0);
  @include for-desktop-up {
    position: relative;
  }
}

.landing-carousel__image-bg {
  @include position(absolute, 0, 0, 0, 0);
  background: {
    size: contain;
    repeat: no-repeat;
    position: center left;
  };
}

.landing-carousel__image-bg-after {
  @include position(absolute, calc(50% - 230px), calc(50% - 310px));
  width: 620px;
  height: 380px;
  background: {
    size: contain;
    repeat: no-repeat;
    position: center;
  };
  @include for-big-desktop-up {
    top: calc(50% - 365px);
    right: calc(50% - 400px);
    width: 800px;
    height: 600px;
  }
}

.landing-carousel__description {
  @include basic-flex(column, center, center);
  background-color: rgba(#000000, 0.25);
  @include for-desktop-up {
    background-color: transparent;
  }
}

.landing-carousel__description-title {
  @include site-font(Leksa, 36px, 600);
  line-height: 36px;
  text-align: center;
  text-shadow: 0 4px 2px rgba(0, 0, 0, 0.5);
  color: #CABDDB;
  position: relative;
  @include for-desktop-up {
    font-size: 100px;
    line-height: 121px;
  }
  @include for-big-desktop-up {
    font-size: 140px;
    line-height: 169px;
  }
}

.landing-carousel__before-title-icon {
  @include position(absolute, 20px, 50%);
  transform: translateX(50%);
  width: 104px;
  height: 104px;
  @include for-big-desktop-up {
    top: 0;
    width: 248px;
    height: 248px;
  }
}

.landing-carousel__description-subtitle {
  @include site-font(Leksa, 20px, 600);
  line-height: 25px;
  text-align: center;
  color: #FFFFFF;
  @include for-desktop-up {
    font-size: 36px;
    line-height: 44px;
  }
  @include for-big-desktop-up {
    font-size: 48px;
    line-height: 50px;
  }
}

.landing-carousel__description-text {
  @include site-font(default, 16px, 400);
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
  padding-top: 23px;
  max-width: 610px;
  text-shadow: 3px 3px 4px black;
  @include for-desktop-up {
    font-size: 20px;
    line-height: 32px;
    max-width: 515px;
  }
  @include for-big-desktop-up {
    font-size: 24px;
    line-height: 38px;
    padding-top: 40px;
    max-width: 610px;
  }
}

.landing-carousel__description-btn {
  max-width: 240px;
  width: 100%;
  margin: 40px auto 0;
  @include for-desktop-up {
    margin: 70px auto 0;
  }
  @include for-big-desktop-up {
    margin: 80px auto 0;
  }
}

.landing-carousel__progress-line {
  @include position(absolute, 11px, -26px);
  width: 52px;
  height: 1px;
  background-color: rgba(#9794C6, 0.1);
  @include for-desktop-up {
    right: -48px;
    width: 96px;
  }
  @include for-big-desktop-up {
    width: 106px;
    right: -53px;
  }
}

.landing-carousel__progress-line-inner {
  left: 0;
  height: 1px;
}

.landing-carousel__progress-line-inner--active {
  width: 100%;
  background-color: rgba(#9794C6, 0.7);
}

.landing-carousel__progress-line-inner--animate {
  animation: animate-progress 8000ms linear;
  background-color: rgba(#9794C6, 0.7);
}

@keyframes animate-progress {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.landing-carousel__dot {
  @include basic-flex(row, center, center);
  width: 24px;
  height: 24px;
  border: 2px solid rgba(#9794C6, 0.7);
  transform: rotate(45deg);
  box-shadow: 0 0 5px 1px rgba(#9794C6, 0.7);
  cursor: pointer;
}

.landing-carousel__inner-dot {
  width: 5px;
  height: 5px;
  background-color: rgba(#9794C6, 0.7);
}

.landing-carousel {
  width: 100%;
  height: 515px;
  position: relative;
  overflow: hidden;
  @include for-desktop-up {
    height: 682px;
  }
  @include for-big-desktop-up {
    height: 960px;
  }
  &__header {
    padding: 0 20px;
    @include for-tablet-landscape-up {
      padding: 0;
    }
  }
  .slide {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    @include for-tablet-portrait-up {
      height: 682px;
    }
    @include for-big-desktop-up {
      height: 960px;
    }
  }

  .fade-enter-active {
    transition: opacity 1s;
  }
  .fade-enter {
    opacity: 0;
  }

  /* GO TO NEXT SLIDE */
  .slide-next-enter-active,
  .slide-next-leave-active {
    transition: transform 1s ease-in-out;
  }
  .slide-next-enter {
    transform: translate(100%);
  }
  .slide-next-leave-to {
    transform: translate(-100%);
  }

  /* GO TO PREVIOUS SLIDE */
  .slide-prev-enter-active,
  .slide-prev-leave-active {
    transition: transform 1s ease-in-out;
  }
  .slide-prev-enter {
    transform: translate(-100%);
  }
  .slide-prev-leave-to {
    transform: translate(100%);
  }
  &__item {
    @include basic-flex(column, space-between, center);
    padding: 0;
    background: {
      image: url("/assets/images_new/gradient-background.png");
      size: 100% 400px;
      repeat: no-repeat;
      position: top;
    }
  }
  &__container {
    display: grid;
    grid-template-columns: 100%;
    width: 100%;
    height: 100%;
    min-height: inherit;
    @include for-desktop-up {
      grid-template-columns: 50% 50%;
    }
    @include for-tablet-portrait-up {
      min-height: 608px;
    }
  }
  &__tabs {
    @include basic-flex(row, center, center);
    @include position(absolute, null,  50%, 15px);
    transform: translateX(50%);
    @include for-desktop-up {
      right: 78px;
      transform: translateX(0);
    }
    @include for-big-desktop-up {
      bottom: 45px;
    }
  }
  &__tab {
    @include basic-flex(column, space-between, center);
    min-width: 95px;
    min-height: 22px;
    padding: 0;
    position: relative;
    cursor: pointer;
    @include for-desktop-up {
      min-height: 62px;
      min-width: 150px;
    }
    @include for-big-desktop-up {
      min-width: 170px;
    }
    &.active {

    }
  }
  &__tab-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  &__tab-title {
    @include site-font(Leksa, 24px, 600);
    text-transform: uppercase;
    color: rgba(#9794C6, 0.5);
    line-height: 29px;
    text-shadow: 0px -2px 10px #000000;
    margin-top: 12px;
    display: none;
    @include for-desktop-up {
      display: inline-block;
    }
    @include for-big-desktop-up {
      font-size: 24px;
    }
    &.active {
      color: #FFFFFF;
    }
    @include for-tablet-portrait-up {
      /*font-size: 16px;*/
      line-height: 19px;
    }
  }
  &__tab-subtitle {
    @include site-font(default, 12px, 500);
    line-height: 16px;
    color: #777189;
    display: none;
    @include for-tablet-portrait-up {
      display: block;
    }
    @include for-big-desktop-up {
      font-size: 14px;
    }
  }
  .landing-carousel__tab-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: {
      size: contain;
      repeat: no-repeat;
      position: center;
    }
    @include for-big-desktop-up {
      width: 30px;
      height: 30px;
    }
  }
  &__header-title {
    @include site-font(default, 30px, 600);
    line-height: 34px;
    text-align: center;
    color: #FFFFFF;
    @include for-tablet-portrait-up {
      font-size: 48px;
      line-height: 56px;
    }
    @include for-big-desktop-up {
      font-size: 60px;
    }
  }
  &__header-description {
    @include site-font(default, 14px, 400);
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
    padding-top: 10px;
    max-width: 680px;
    @include for-tablet-portrait-up {
      font-size: 16px;
      line-height: 26px;
    }
    @include for-big-desktop-up {
      font-size: 18px;
    }
  }
  &__footer-description-btn {
    @include for-big-desktop-up {
      transform: scale(1.15);
    }
  }
  &__footer {
    width: 100%;
    max-width: 1078px;
    margin: 0 auto;
    padding-bottom: 95px;
    padding-left: 20px;
    padding-right: 20px;
    @include for-tablet-portrait-up {
      padding-bottom: 130px;
      padding-left: 0;
      padding-right: 0;
    }
    @include for-big-desktop-up {
      padding-bottom: 140px;
    }
  }
  &__footer-description {
    @include basic-flex(column, space-between, flex-start);
    min-height: 164px;
    padding: 20px;
    background: {
      image: linear-gradient(90deg, rgba(#141623, 0.7) 50%, rgba(#141623, 0) 100%);
    }
    position: relative;
    @include for-tablet-portrait-up {
      @include basic-flex(row, space-between, center);
      padding: 0 56px;
    }
    @include for-big-desktop-up {
      min-height: 190px;
    }
    &::before {
      content: '';
      @include position(absolute, 0, null, 0, 0);
      display: inline-block;
      width: 3px;
      background: {
        image: linear-gradient(180deg, #D94FC7 0%, #FF905A 100%);
      }
    }
  }
  &__footer-description-title {
    @include site-font(default, 20px, 600);
    line-height: 26px;
    text-transform: uppercase;
    color: #FFFFFF;
    text-align: left;
    padding-bottom: 9px;
    @include for-tablet-portrait-up {
      font-size: 30px;
      line-height: 35px;
      padding-bottom: 15px;
    }
    @include for-big-desktop-up {
      font-size: 34px;
    }
  }
  &__footer-description-subtitle {
    @include site-font(default, 14px, 400);
    color: #FFFFFF;
    text-align: left;
    max-width: 663px;
    padding-bottom: 20px;
    @include for-tablet-portrait-up {
      font-size: 16px;
      line-height: 28px;
      padding-bottom: 0;
    }
    @include for-big-desktop-up {
      font-size: 18px;
    }
  }
}

$tabsIcon: (
  altar: (
    'tab-icon--altar.svg'
  ),
  arena: (
    'tab-icon--arena.svg'
  ),
  bosses: (
    'tab-icon--bosses.svg'
  ),
  marketplace: (
    'tab-icon--marketplace.svg'
  ),
  monsters: (
    'tab-icon--monsters.svg'
  ),
);
</style>
